const SECONDS_PER_HOUR = 3600
const SECONDS_PER_MINUTE = 60

/** Segundos que faltan hasta `instant` (ISO) desde `nowMs`; 0 si ya pasó o no se sabe. */
export function secondsUntil(instant: string | null, nowMs: number): number {
  if (instant === null) return 0
  const target = Date.parse(instant)
  return Number.isFinite(target) ? Math.max(0, Math.ceil((target - nowMs) / 1000)) : 0
}

function formatUnit(value: number, unit: 'hour' | 'minute', locale: string): string {
  return new Intl.NumberFormat(locale, { style: 'unit', unit, unitDisplay: 'long' }).format(value)
}

/** «5 horas», «20 minutos»…: el hueco `{time}` de `chat.limitBody` («en {time}»). */
export function formatRetryDuration(seconds: number, locale: string): string {
  if (seconds >= SECONDS_PER_HOUR) {
    return formatUnit(Math.round(seconds / SECONDS_PER_HOUR), 'hour', locale)
  }
  return formatUnit(Math.max(1, Math.ceil(seconds / SECONDS_PER_MINUTE)), 'minute', locale)
}
